import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ExternalDataCachePageUI from './ExternalDataCachePageUI'

class ExternalDataCachePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      externalDataCacheList: null,
      lastKey: null,
      hasMore: false,
      gettingMore: false,
      currentPage: 1,
      pageHistory: [],
      pageData: {},
      hasPrevious: false
    }
  }

  componentDidMount() {
    this.getExternalDataCache(this.props.context)
  }

  render() {
    return (
      <ExternalDataCachePageUI
        context={this.props.context}
        errorList={this.state.errorList}
        externalDataCacheList={this.state.externalDataCacheList}
        lastKey={this.state.lastKey}
        hasMore={this.state.hasMore}
        hasPrevious={this.state.hasPrevious}
        gettingMore={this.state.gettingMore}
        currentPage={this.state.currentPage}
        onRefreshClick={this.onRefreshClick}
        onNextClick={this.onNextClick}
        onPreviousClick={this.onPreviousClick}
        onDeleteClick={this.onDeleteClick}
      />
    )
  }

  getExternalDataCache(context, lastEvaluatedKey = null) {
    const cacheManager = new CacheManager({
      resource: '/api/su/externalDataCache',
      cacheKey: CacheKeys.ExternalDataCache(lastEvaluatedKey),
      callback: this.getExternalDataCacheCallback,
      ttlInSecs: 600,
    })

    let requestParams = {}
    if (lastEvaluatedKey) {
      requestParams.lastEvaluatedKey = lastEvaluatedKey
      requestParams.limit = 10
    } else {
      requestParams.limit = 10
    }

    if (lastEvaluatedKey) {
      CacheManager.removeObject(CacheKeys.ExternalDataCache(lastEvaluatedKey))
    }

    cacheManager.getObject2(context, null, requestParams)
  }

  getExternalDataCacheCallback = (response) => {
    const pageData = { ...this.state.pageData }
    pageData[this.state.currentPage] = {
      externalDataCacheList: response.externalDataCacheList || [],
      lastKey: response.lastKey,
      hasMore: response.hasMore,
      errorList: response.errorList
    }

    this.setState({
      errorList: response.errorList,
      externalDataCacheList: response.externalDataCacheList || [],
      lastKey: response.lastKey,
      hasMore: response.hasMore,
      gettingMore: false,
      pageData: pageData,
      hasPrevious: this.state.currentPage > 1
    })
  }

  onNextClick = () => {
    if (this.state.gettingMore || !this.state.hasMore || !this.state.lastKey) {
      return
    }

    const keyToStore = this.state.currentPage === 1 ? null : this.state.lastKey
    const newPageHistory = [...this.state.pageHistory, keyToStore]

    this.setState({
      gettingMore: true,
      pageHistory: newPageHistory,
      hasPrevious: true,
      currentPage: this.state.currentPage + 1
    }, () => {
      this.getExternalDataCache(this.props.context, this.state.lastKey)
    })
  }

  onPreviousClick = () => {
    if (this.state.gettingMore || !this.state.hasPrevious || this.state.pageHistory.length === 0) {
      return
    }

    const previousPage = this.state.currentPage - 1
    if (previousPage < 1) {
      return
    }

    const previousPageData = this.state.pageData[previousPage]
    if (previousPageData) {
      this.setState({
        gettingMore: true,
        hasPrevious: previousPage > 1,
        currentPage: previousPage,
        externalDataCacheList: previousPageData.externalDataCacheList,
        lastKey: previousPageData.lastKey,
        hasMore: previousPageData.hasMore,
        errorList: previousPageData.errorList,
        gettingMore: false
      })
    } else {
      const newPageHistory = [...this.state.pageHistory]
      const previousKey = newPageHistory[newPageHistory.length - 1]
      newPageHistory.pop()

      this.setState({
        gettingMore: true,
        pageHistory: newPageHistory,
        hasPrevious: previousPage > 1,
        currentPage: previousPage
      }, () => {
        this.getExternalDataCache(this.props.context, previousKey)
      })
    }
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.ExternalDataCache())
    this.setState({
      errorList: null,
      externalDataCacheList: null,
      lastKey: null,
      hasMore: false,
      currentPage: 1,
      pageHistory: [],
      pageData: {},
      hasPrevious: false
    }, () => {
      this.getExternalDataCache(this.props.context)
    })
  }

  onDeleteClick = (id) => {
    if (!id) {
      return
    }

    const url = `/api/su/externalDataCache/delete/${id}`
    RestApiUtils.delete(this.props.context, url, this.onDeleteCallback, null)
  }

  onDeleteCallback = (response) => {
    const errorList = response && response.errorList ? response.errorList : []
    if (!errorList || errorList.length === 0) {
      this.onRefreshClick()
    }
  }
}

export default ExternalDataCachePageSF


